import { useQueryState } from "context/queryState"
import { useAppSelector } from "reducers/store"

import styled from "styled-components"

import Spinner from "components/EvtKit/loading-spinner/LoadingSpinner"
import { useCallback } from "react"
import { useParams } from "react-router-dom"

import ExtendedRJSForm from "components/RJSF/ExtendedRJSForm"
import Heading from "components/Typography/Heading"
import { showToast } from "reducers/toast/toast-actions"
import { useAppDispatch } from "reducers/store"
import { useNavigate } from "react-router-dom"
import { WEBHOOK_FORM } from "reducers/webhook/webhook-actions"
import ApiWebhook from "api/ApiWebhook"
import useWebhookRequest, { WebhookSubmitTypes } from "./hooks/useWebhookRequest"
import { useQueryClient } from "react-query"
import { FormValidation } from "@rjsf/utils"
import { validateWebhookPath } from "utils/auth/authHelper"

const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 24px;

  // Space all direct children (use margin top)
  & > * {
    margin-top: 16px;
  }
`

const WebhookForm = () => {
  const params = useParams()
  const appDispatch = useAppDispatch()
  const navigate = useNavigate()
  const queryClient = useQueryClient()

  useQueryState([WEBHOOK_FORM, params.id], async () => await new ApiWebhook().getById(params.id), WEBHOOK_FORM, {
    refetchOnMount: true
  })

  const { data, loading } = useAppSelector((state) => state.webhook.webhookForm)

  const isUpdating = !!params.id && params.id !== "create"

  const request = {
    type: isUpdating ? "update" : ("create" as WebhookSubmitTypes),
    toastSuccessText: isUpdating ? "atualizado" : "criado",
    toastErrorText: isUpdating ? "atualizar" : "criar"
  }

  const onSuccess = useCallback(() => {
    navigate("/webhooks")
    appDispatch(showToast(`Webhook ${request.toastSuccessText} com sucesso!`))
    if (isUpdating) {
      queryClient.invalidateQueries(WEBHOOK_FORM)
    }
  }, [isUpdating, request.toastSuccessText])

  const { onSubmit } = useWebhookRequest(request.type, onSuccess, `Erro ao tentar ${request.toastErrorText} Webhook`)

  const handleSubmit = useCallback(
    (data) => {
      onSubmit(data.formData)
    },
    [onSubmit]
  )

  const customValidate = useCallback((formData: App.IWebhook | undefined, errors: FormValidation<App.IWebhook>) => {
    if (formData?.product === "No products available") {
      errors?.product?.addError("No products available. You need a product in order to create a webhook.")
    }

    if (formData?.path && !validateWebhookPath(formData?.path)) {
      errors?.path?.addError("The path must consist of letters and hyphens only, with hyphens not at the start or end.")
    }

    return errors
  }, [])

  return (
    <Container>
      <Heading variant="h2">{isUpdating ? "Editar" : "Criar"} Webhook</Heading>
      {loading && <Spinner />}
      {!loading && (
        <ExtendedRJSForm
          id="tour-options-details-form"
          schema={data.formSchema}
          uiSchema={data.uiSchema}
          formData={data.formData}
          onSubmit={handleSubmit}
          busy={loading}
          customValidate={customValidate}
        />
      )}
    </Container>
  )
}

export default WebhookForm
